<template>
	<div class="relative flex flex-grow cursor-pointer flex-col overflow-hidden rounded-xl">
		<div
			class="absolute bottom-0 left-0 right-0 top-0"
			:style="{
				backgroundImage: `url('/img/bg_pattern.jpg')`,
				backgroundRepeat: 'repeat',
				backgroundSize: '300px 300px'
			}"
		></div>
		<img
			v-if="category.image_id"
			:src="$config.public.baseUrl + category.image_thumb2"
			alt=""
			class="absolute left-0 top-0 h-full w-full object-cover"
		/>
		<div
			class="absolute bottom-0 left-0 right-0 top-0 bg-primary-dark opacity-90"
			:style="{
				backgroundColor: category.color ? tinycolor(category.color).darken(10).toString() : undefined
			}"
		></div>
		<div class="z-[1] flex flex-grow flex-col p-5">
			<h3 class="text-white mb-4 text-2xl font-bold drop-shadow-xl">
				{{ $stringUtil.getLocalText(category.title) || "~" }}
			</h3>
			<span class="text-white mb-12 text-base font-normal drop-shadow-md">
				{{ $stringUtil.getLocalText(category.content) || "~" }}
			</span>
			<div class="flex-grow"></div>
			<div class="text-white flex items-center self-start drop-shadow-md">
				<span class="me-1 text-base font-bold">
					{{ $t("view_helps") }}
				</span>
				<Icon name="mdi:arrow-left" class="h-6 w-6" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import tinycolor from "tinycolor2"
import type { Category } from "~/models/category"

defineProps<{
	category: Category
}>()
</script>
